var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95959 2.05196L11.3329 5.4253L4.70759 12.052C4.52302 12.2366 4.29345 12.3699 4.04159 12.4386L0.63092 13.3686C0.545914 13.3917 0.456323 13.3919 0.371215 13.3692C0.286107 13.3465 0.208503 13.3018 0.146255 13.2394C0.0840067 13.1771 0.0393247 13.0995 0.0167305 13.0143C-0.00586367 12.9292 -0.00556824 12.8396 0.0175869 12.7546L0.947587 9.34396C1.01632 9.0921 1.1496 8.86253 1.33425 8.67796L7.95825 2.05196H7.95959ZM12.6863 0.698629C13.1336 1.14596 13.3849 1.75268 13.3849 2.3853C13.3849 3.01792 13.1336 3.62463 12.6863 4.07196L12.0396 4.71863L8.66625 1.3453L9.31292 0.698629C9.76026 0.251304 10.367 0 10.9996 0C11.6322 0 12.2389 0.251304 12.6863 0.698629Z",
    fill: "#659DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePen);
export default __webpack_public_path__ + "static/media/bluePen.3eca456d945e6275d4cb34db2bd2d9d4.svg";
export { ForwardRef as ReactComponent };